<template>
    <v-container>
      <create-or-update-exercise-dialog
        :dialog="createOrUpdateDialog"
        :editedItem="editedItem"
        @close="closeCreateOrUpdateDialog($event)"
      />
      <delete-exercise-dialog
        :dialog="destroyDialog"
        :itemToBeDeleted="itemToBeDeleted"
        @close="closeDestroyDialog($event)"
      />
      <v-row
        class="align-center"
        mt-5
      >
        <v-col
          cols="4"
        >
          <search-field
            label="Busque por nome de Exercício"
            :loading="loadingSearch"
            @searchText="searchText = $event"
          />
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="1"
               class="text-right">
          <span class="mr-2 caption">
            <strong>Filtros:</strong>
          </span>
        </v-col>
        <v-col cols="3">
          <v-autocomplete
            v-model="exerciseType"
            :items="exerciseTypes"
            solo
            dense
            item-text="name"
            item-value="text"
            required
            hide-details
            return-object
          />
        </v-col>
        <v-col
          cols="3"
          :md="3"
          class="ml-4 text-right">
          <v-btn
            color="primary"
            dark
            @click="editItem({})"
          >
            <v-icon
              size="20"
              class="mr-1"
            >
              mdi-dumbbell
            </v-icon> Adicionar Exercícios
          </v-btn>
        </v-col>

      </v-row>
      <v-row
          mt-5
        >
          <v-col xs12>
            <v-data-table
              :headers="headers"
              :items="exercises"
              disable-pagination
              disable-sort
              hide-default-footer
              no-data-text=""
              loading-text="Carregando... Aguarde"
              class="elevation-1"
            >
              <template v-slot:item.exercise_type="{ item }">
                {{ translateExerciseType(item.exercise_type) }}
              </template>
              <template v-slot:item.muscle_groups="{ item }">
                {{ muscleGroupsList(item.muscle_groups) }}
              </template>
              <template v-slot:item.worked_postural_deviations="{ item }">
                {{ posturaldeviationsList(item.postural_deviations) }}
              </template>
              <template v-slot:item.link="{ item }">
                <a :href="item.link"
                   v-if="item.link"
                   target="_blank">Visualizar</a>
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  v-if="isMyScope(item)"
                  class="mr-2"
                  fab
                  x-small
                >
                  <v-icon
                    color="secondary"
                    small
                    @click="editItem(item)"
                  >
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  v-if="isMyScope(item)"
                  fab
                  x-small
                >
                  <v-icon
                    color="secondary"
                    small
                    @click="deleteItem(item)"
                  >
                    mdi-delete
                  </v-icon>
                </v-btn>

              </template>
              <template v-slot:footer>
                <div class="full-width">
                  <infinite-loading
                    @infinite="infiniteHandler">
                    <template slot="no-more">Não há mais itens cadastrados</template>
                    <template slot="no-results">Não há itens cadastrados</template>
                  </infinite-loading>
                </div>

              </template>
            </v-data-table>
          </v-col>
        </v-row>
    </v-container>

</template>

<script>
import ExerciseService from '@/services/user-exercises-service'
import CreateOrUpdateExerciseDialog from '@/components/personal/configurations/exercises/CreateOrUpdateExerciseDialog'
import DeleteExerciseDialog from '@/components/personal/configurations/exercises/DeleteExerciseDialog'
import { mapActions, mapGetters } from 'vuex'
import InfiniteLoading from 'vue-infinite-loading'
import SearchField from '@/components/base/SearchField'

export default {
  name: 'ExercisesList',
  components: {
    CreateOrUpdateExerciseDialog,
    DeleteExerciseDialog,
    InfiniteLoading,
    SearchField
  },
  mounted () {
    this.setLoader({ show: true })
  },
  data () {
    return {
      ...mapActions('base', ['setLoader', 'setSnackbar']),
      nextPage: 1,
      totalPages: 0,
      searchText: '',
      state: null,
      resetList: false,
      exerciseType: { name: 'Todos', value: 'all' },
      exerciseTypes: [
        { name: 'Todos', value: 'all' },
        // { name: 'Aeróbico Contínuo', value: 'aerobic' },
        // { name: 'Hiit', value: 'hiit' },
        { name: 'Mobilidade', value: 'mobility' },
        { name: 'Alongamento', value: 'stretching' },
        { name: 'Resistido', value: 'resistence' },
        { name: 'Liberação Miofascial', value: 'myofascial_release' },
        { name: 'Funcional', value: 'functional' },
        { name: 'Manobras Respiratórias/core', value: 'manobra_resp' },
        { name: 'Exercícios Aeróbicos', value: 'exerc_aerobicos' }],
      exercises: [],
      headers: [
        { text: 'Exercicio', sortable: false, value: 'name' },
        { text: 'Tipo de Exercício', value: 'exercise_type', width: 140, align: 'center' },
        { text: 'Grupos Musculares Trabalhados', width: 200, align: 'center', value: 'muscle_groups' },
        { text: 'Desvios Posturais Trabalhados', width: 200, align: 'center', value: 'worked_postural_deviations' },
        { text: 'Video Explicativo', value: 'link', width: 140, align: 'center' },
        { text: '', value: 'actions', width: 140, align: 'center' }
      ],
      loadingSearch: true,
      editedItem: {},
      itemToBeDeleted: {},
      createOrUpdateDialog: false,
      destroyDialog: false
    }
  },
  computed: {
    ...mapGetters('auth', ['user'])
  },
  methods: {
    infiniteHandler ($state) {
      this.state = $state
      this.resetList = false
      if (this.nextPage === null) {
        $state.complete()
      } else {
        this.fetchExercises()
      }
    },
    fetchExercises () {
      ExerciseService
        .all({ q: this.searchText, page: this.nextPage, exerciseType: this.exerciseType.value })
        .then(({ data }) => {
          if (data.exercises.length > 0) {
            if (this.resetList) {
              this.exercises = []
            }
            this.exercises.push(...data.exercises)
            this.nextPage = data.meta.next_page
            this.totalPages = data.meta.total_count
            this.state.loaded()
          } else {
            this.exercises = []
            this.state.complete()
          }
        })
        .catch(({ response }) => {
          this.setSnackbar({
            color: 'error',
            show: true,
            message: response.data.errors.detail
          })
        })
        .finally(() => {
          this.loadingSearch = false
          this.setLoader({ show: false })
        })
    },
    resetInfinityLoadAndPagination () {
      this.exercises = []
      this.state.reset()
      this.nextPage = 1
      this.resetList = true
    },
    editItem (item) {
      this.editedItem = Object.assign({}, item)
      this.createOrUpdateDialog = true
    },
    deleteItem (item) {
      this.itemToBeDeleted = item
      this.destroyDialog = true
    },
    closeCreateOrUpdateDialog (state) {
      this.createOrUpdateDialog = false
      this.editedItem = {}
      if (state) this.resetInfinityLoadAndPagination()
    },
    closeDestroyDialog () {
      this.destroyDialog = false
      this.resetInfinityLoadAndPagination()
    },
    translateExerciseType (exerciseType) {
      try {
        const type = this.exerciseTypes.find(type => type.value === exerciseType)
        return type.name
      } catch (error) {
        return 'Sem classificação'
      }
    },
    muscleGroupsList (items) {
      return items.map(item => item.name).join(', ')
    },
    posturaldeviationsList (items) {
      return items.map(item => item.name).join(', ')
    },
    isMyScope (exercise) {
      return exercise.user_id && exercise.user_id === this.user.id
    }
  },
  watch: {
    exerciseType () {
      this.resetInfinityLoadAndPagination()
    },
    searchText () {
      const qLength = this.searchText.length
      if (qLength > 0 && qLength < 3) return
      this.loadingSearch = true
      this.resetInfinityLoadAndPagination()
    }
  }
}
</script>
